
import { useState, useRef, useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { AnimatePresence, motion } from 'framer-motion';
import Classes from './style.module.css';

export default function LevelsDropDown({ selected, onChange }) {
    const options = [
        'Entry Level',
        'Associate',
        'Specialist',
        'Supervisor',
        'Manager',
        'Senior Manager',
        'Director',
        'Senior Director',
        'Vice President',
        'Managing Director',
        'Partner',
        'C-Suite Executive',
        'Founder/Co-Founder',
        'Board Member/Advisor'
    ].map((label) => ({ value: label, label }));

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const ref = useRef(null);

    // click‑outside close
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const toggleSelect = (val) => {
        const newSel = selected.includes(val)
            ? selected.filter((v) => v !== val)
            : [...selected, val];
        onChange(newSel);
    };

    const headerLabel = selected.length
        ? selected.slice(0, 5).join(', ') + (selected.length > 5 ? ` +${selected.length - 5}` : '')
        : <p style={{ color: '#c7c7c7' }} >Select preferred mentor level</p>;

    return (
        <div className={Classes.dropDown} ref={ref}>
            {/* Header */}
            <div className={Classes.SelectinputField} onClick={() => setOpen(!open)}>
                <p> {headerLabel} </p>
                <img
                    src="/assets/icons/arrow-down.svg"
                    alt="toggle"
                    style={{ height: '10px', transform: open ? 'rotate(180deg)' : undefined }}
                />
            </div>

            {/* Body */}
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: -5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        transition={{ duration: 0.15 }}
                        className={Classes.dropDownBody}
                    >
                        <div className={Classes.dropDownBodyInner}>
                            {/* search */}
                            <div className={Classes.stickyCon}>
                                <div className={Classes.searcCon}>
                                    <input
                                        placeholder="Search Level of Experience"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                            {options
                                .filter((o) => o.label.toLowerCase().includes(search.toLowerCase()))
                                .map((option, idx) => (
                                    <div
                                        key={idx}
                                        className={`${Classes.dropDownElem} ${selected.includes(option.value) ? Classes.activeDropElem : ''}`}
                                        onClick={() => toggleSelect(option.value)}
                                    >
                                        <Checkbox
                                            checked={selected.includes(option.value)}
                                            onChange={() => toggleSelect(option.value)}
                                            sx={{
                                                color: 'var(--primary-color)',
                                                padding: '5px',
                                                '&.Mui-checked': { color: 'var(--primary-color)' },
                                                '& .MuiSvgIcon-root': { fontSize: 18 },
                                            }}
                                        />
                                        <label> <h5>{option.label}</h5> </label>
                                    </div>
                                ))}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
